module.exports = __webpack_public_path__ + "img/capture.f8b73a59.jpg";